angular.module('callX').controller('RealTimeMapCtrl', ['$scope', 'RealTimeService', 'UserService', '$state', function($scope, RealTimeService, UserService, $state) {

    $scope.realTimeData = {};
    var currentUserData = UserService.getCurrentUserData();

    var setData = function () {

    };

    var fetchRealTimeData = function(){
        var callbacks = {
            success: function(data) {
//                console.log("data",data);
                $scope.realTimeData = data.data;
                setData();
                /*if($state.current.name=='app.real-time.list'){
                    setTimeout(function(){
                        fetchRealTimeData();
                    }, 15000);
                }*/
            },
            failure: function(data) {
            }
        };
        RealTimeService.getRealTimeData(currentUserData.id, moment().tz(currentUserData.time_zone).format("YYYY-MM-DD HH:mm:ss"), callbacks);
    };

    if(currentUserData.id!=undefined){
        fetchRealTimeData();
    }

    $scope.$on('currentUserUpdate', function(event, userData) {
        currentUserData = userData;
        fetchRealTimeData();
    });

}]);